const MenuAdmin = [
  {
    heading: "Akongo Animal Welfare Monitor",
  },

  {
    name: "Centre de pilotage",
    icon: "fa fa-tachometer-alt",
    path: "DashboardNext",
    translate: "sidebar.nav.DASHBOARD",
  },
  {
    name: "Mes rappels",
    icon: "fa fa-stopwatch",
    path: "MyActivitiesView",
    translate: "sidebar.nav.MY_REMINDERS",
  },
  {
    name: "Gestion des tâches",
    icon: "fa fa-tasks",
    path: "TaskManagementView",
    translate: "sidebar.nav.TASK_MANAGEMENT",
  },
  {
    name: "Vue Live",
    icon: "fa fa-broadcast-tower",
    path: "LiveSectorView",
    translate: "sidebar.nav.LIVE_VIEW",
  },
  {
    name: "Timeline",
    icon: "fa fa-stream",
    path: "Timeline",
    translate: "sidebar.nav.TIMELINE",
  },

  {
    heading: "Gestion du parc",
    translate: "sidebar.heading.PARC_MANAGEMENT",
  },
  {
    name: "Gestion des secteurs",
    icon: "fa fa-map-marked-alt",
    path: "SectorListView",
    translate: "sidebar.nav.SECTOR_MANAGEMENT",
  },
  {
    name: "Gestion des enclos",
    icon: "fa fa-th-large",
    path: "EnclosureListView",
    translate: "sidebar.nav.ENCLOSURE_MANAGEMENT",
  },
  {
    name: "Gestion des individus",
    icon: "fa fa-paw",
    translate: "sidebar.nav.ANIMAL_MANAGEMENT",
    path: "specieAnimalsListView",
  },
  {
    name: "Gestion des groupes",
    icon: "fa fa-layer-group",
    translate: "sidebar.nav.GROUP_MANAGEMENT",
    path: "GroupListView",
  },
  {
    name: "Gestion des enrichissements",
    icon: "fa fa-gift",
    path: "EnrichListView",
    translate: "sidebar.nav.ENRICHMENT_MANAGEMENT",
  },

  {
    heading: "Données BEA",
    translate: "sidebar.heading.BEA_DATA",
  },

  {
    name: "Gestion des campagnes",
    icon: "fa fa-bullhorn",
    path: "CampaignListView",
    translate: "sidebar.nav.CAMPAIGN_MANAGEMENT",
  },
  {
    name: "Historique collectes",
    icon: "fa fa-history",
    path: "EvalHistory",
    translate: "sidebar.nav.HISTORY",
  },
  {
    name: "Grilles d'évaluation",
    icon: "fa fa-bolt",
    path: "FastEvalGroupListView",
    translate: "sidebar.nav.FAST_EVALUATION",
  },
  {
    name: "Consulter les évaluations",
    icon: "fa fa-clipboard-check",
    path: "CampaignQuizzMonitoringView",
    translate: "sidebar.nav.EVALUATION_MONITORING",
  },
  {
    name: "Bilan d'Activité",
    icon: "fa fa-chart-line",
    translate: "sidebar.nav.BILAN",
    path: "cirManagementView",
  },

  {
    heading: "Ressources",
    translate: "sidebar.heading.RESSOURCES",
  },

  {
    name: "Consulter les questionnaires",
    path: "QuizzListViewReadOnly",
    translate: "sidebar.nav.QUIZZ_MONITORING",
  },

  {
    name: "Consulter les éthogrammes",
    path: "obsListViewReadOnly",
    translate: "sidebar.nav.ETHO_MONITORING",
  },

  {
    heading: "Mon compte AWM",
    translate: "sidebar.heading.MY_ACCOUNT",
  },
  {
    name: "Gérer mon compte",
    translate: "sidebar.nav.USER_SETTINGS",
    path: "userSettings",
  },
  {
    name: "Gérer mon établissement",
    translate: "sidebar.nav.ZOO_MANAGEMENT",
    path: "zooDetails",
  },
  {
    name: "Inviter des utilisateurs",
    translate: "sidebar.nav.USER_CREATION",
    path: "userCreation",
  },
];

export default MenuAdmin;
